/**
 * Short relative-time formatter used on the Platform Users page. Matches the
 * mockup spelling: "just now", "2h ago", "1d ago", "Apr 22", "never".
 *
 * - Returns "—" when there's no value (callers usually surface "never" instead).
 * - Anything > a week falls back to an absolute "Mon DD" month/day label.
 */
export function humanizeRelativeDate(
  iso: string | null | undefined,
  now: Date = new Date(),
): string {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return "—";
  const diff = now.getTime() - t;
  if (diff < 0) return "just now";
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
  }).format(new Date(iso));
}
